import { AuthWrapper } from "components";

import LoginForm from "./LoginForm";

const Home = () => {
  return <AuthWrapper body={<LoginForm />} />;
};

export default Home;
